'use client'
// Carte « AI Adventure Engine » (accès au jeu narratif). Extrait de app/page.tsx.

export function QuizCard() {
  const quizUrl =
    '/messages?msg=' +
    encodeURIComponent(
      'Lance-moi une aventure interactive québécoise avec quiz, choix narratifs et conséquences.'
    )

  return (
    <div style={{
      display: 'flex', gap: 18, padding: '22px',
      background: 'linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))',
      border: '1px solid var(--border)', borderRadius: 16,
      alignItems: 'center', position: 'relative', overflow: 'hidden',
    }}>
      {/* Glow */}
      <div style={{
        position: 'absolute', left: '-50px', top: '-50px',
        width: '140px', height: '140px', borderRadius: '50%',
        background: 'rgba(79,124,255,0.08)', filter: 'blur(60px)',
      }} />

      <div style={{
        width: 54, height: 54, borderRadius: 14, flexShrink: 0,
        background: 'rgba(79,124,255,0.1)', border: '1px solid rgba(79,124,255,0.2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 22, color: 'var(--accent)',
      }}>
        ◈
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          <div className="font-display" style={{ fontSize: 15, fontWeight: 700, color: 'var(--white)' }}>
            AI Adventure Engine
          </div>
          <span style={{
            fontSize: 9, padding: '3px 6px', borderRadius: 999,
            background: 'rgba(0,212,170,0.1)', border: '1px solid rgba(0,212,170,0.2)',
            color: 'var(--teal)', fontFamily: 'var(--font-mono)',
          }}>
            LIVE
          </span>
        </div>

        <div style={{ fontSize: 12, color: 'var(--text-muted)', fontFamily: 'var(--font-mono)', lineHeight: 1.6 }}>
          Histoires interactives générées par IA, quiz québécois, univers RPG,
          conséquences dynamiques, mémoire persistante et NPC autonomes.
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
          {['Narratif IA', 'Choix multiples', 'Mémoire', 'NPC', 'Multijoueur'].map(t => (
            <span key={t} style={{
              fontSize: 9, padding: '4px 7px', borderRadius: 999,
              background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border-dim)',
              color: 'var(--text-secondary)', fontFamily: 'var(--font-mono)',
            }}>
              {t}
            </span>
          ))}
        </div>
      </div>

      <a
        href={quizUrl}
        style={{
          flexShrink: 0, padding: '10px 18px', background: 'var(--accent)',
          borderRadius: 10, color: 'white', textDecoration: 'none',
          fontSize: 12, fontFamily: 'var(--font-mono)', fontWeight: 700,
          transition: 'all 0.15s ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.opacity = '0.9' }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.opacity = '1' }}
      >
        Démarrer →
      </a>
    </div>
  )
}
